import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { AuthService } from '../../services/auth.service';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { HttpParams } from '@angular/common/http';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import config from '../../../assets/config.json';
import cookies from 'js-cookie';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('privacyModalref', { static: false }) privacyModalreff!: ElementRef;
  [x: string]: any;
  modalReference: any;
  inputType: string = 'password';
  frmLogin: FormGroup;
  isShowStatusDiv: boolean = false;
  userAcceptancePrivacyPolicyContent: string = ''
  //isAzureFlag can be set to true for Azure Authentication
  isAzureFlag: boolean = false;
  isQueryParamExist: boolean = false;
  queryParams: any;
  showdiv: boolean = false;
  contentListArr: any = [
    {
      title: 'Personal data that we collect'
    },
    {
      title: 'How we use your personal data'
    },
    {
      title: 'When we share personal data'
    },
    {
      title: 'Where we store and process personal data'
    },
    {
      title: 'How we secure personal data'
    },
    {
      title: 'Cookies'
    },
    {
      title: 'Children'
    },
    {
      title: 'Your rights and your personal data'
    },
    {
      title: 'How long do we keep your personal data?'
    },
    {
      title: 'Changes'
    },
    {
      title: 'Protection Of Data Provided'
    },
    {
      title: 'Your Obligations and Governing Laws'
    },
    {
      title: 'Questions/ Contact Information'
    }
  ];
  @ViewChild('userAcceptancePrivacyPolicyModal') userAcceptancePrivacyPolicyModal: ElementRef;

  constructor(private formBuilder: FormBuilder, private authService: AuthService,
    private router: Router, public commonService: CommonService, private modalService: NgbModal, private dataService: DataService,
    @Inject(MAT_DATE_FORMATS) private dateFormats, private msalservice: MsalService, private route: ActivatedRoute, private dialog: MatDialog, private renderer: Renderer2, private memorystore: MemoryStorageService
  ) {
    this.isAzureFlag = (this.dataService.Authentication_Type == "AZURE" ? true : false);
    this.inputType = 'password';


    this.route.queryParams.subscribe(params => {
      let k = Object.keys(params)

      if (k.length > 0) {
        this.isQueryParamExist = true;
        this.queryParams = params;
      }
    });
  }

  ngOnInit(): void {
    this.commonService.detecookie();
    // cookies.remove('15ea53b8e6a25d02cb9b107a68fc60ccdc97cd43c4128dcc8a391b7feb844635');
    if (this.dataService.is_sso == true && !this.isQueryParamExist) {
      //this.router.navigate(['/sso-logout']);
      let url = this.dataService.sso_url;
      window.location.href = url;
    } else {
      this.showdiv = true;
    }


    this.authService.csrfRefresh().then(() => {
      localStorage.clear();
      sessionStorage.clear();
    });
    // if (this.dataService.is_sso == true) {
    //   //this.router.navigate(['/sso-logout']);
    //   let url = this.dataService.sso_url;
    //   window.location.href = url;
    // }
    // else {
    //   this.router.navigate(['/login']);
    // }

    let _this = this;
    setTimeout(function () {
      _this.loadScript('/assets/js/jquery.js');
      _this.loadScript('/assets/js/materialize.js');
      // _this.loadScript('/assets/js/gsap.js');
    }, 2000);
    setTimeout(function () {
      _this.loadScript('/assets/js/page.js');
    }, 4000);
    // setTimeout(function () {
    //  _this.loadScript('/assets/js/login_animation.js');
    //}, 5000);

    $(".statusdiv").hide();
    setTimeout(function () {
      $(".statusdiv").show();
    }, 2000);

    localStorage.clear();
    // cookies.clear();
    this.createForm();
    this.userAcceptancePrivacyPolicyContent = '<div><h4>Website Privacy Statement</h4><h5>Introduction</h5>Your privacy is important to us. ' +
      'We believe it is important you know how we treat the information we receive from you, on the Internet. This privacy statement explains what personal data we, ' +
      'Tata Consultancy Services Limited (&#8220;Tata Consultancy Services&#8221;, &#8220;TCS&#8221; or &#8220;we&#8221;), collect from you, through our interactions with you on this website, ' +
      'and how we use that data.<p><p>&#8220;TCS&#8221; Web site may contain links to other sites such as TCS partners and affiliates. While we try to link only to sites that share our high standards and respect for privacy, ' +
      'we are not responsible for the content or the privacy practices employed by other sites.</p><h5>Scope of Data</h5><p>Tata Consultancy Services collects data to operate this website. ' +
      ' You provide some of this data directly, such as when you register for an event, subscribe to a newsletter or submit a request for further information, or contact us for support.</p><p>In general, ' +
      'you can visit TCS on the World Wide Web without telling us who you are. Our web servers collect the domain names, not the e-mail addresses, of visitors. This information is aggregated to measure the number of visits, ' +
      'average time spent on the site, pages viewed, etc. TCS uses this information to measure the use of our site and to improve the content of its site.</p><p>There are times, however, ' +
      'when we may need more information from you, such as your name and address. Usually, the contact information we collect is used only by us to respond to your inquiry, ' +
      'process an order or allow you to access specific account information. Occasionally, we may make the e-mail addresses, of those who provide information, ' +
      'available to other reputable organizations whose products or services we think you may find interesting. In these cases, you will be offered an opportunity to limit the access of your information to such third parties.</p><p>If you register with one of &#8220;TCS&#8221; business units online, ' +
      'they may use this information to provide you with custom information about &#8220;TCS&#8221; offering in support of your business needs. Cookies may be used to provide you with tailored information. ' +
      'A cookie is a tiny element of data that a web site can send to your browser, which may then be stored on your hard drive so we can recognize you when you return. You may set your browser to notify you when you receive a cookie.' +
      '</p><p>At times we conduct online surveys to better understand the needs and profiles of our visitors.</p><p>We get some of it by recording how you interact with our website by, for example, ' +
      'using technologies like cookies, or receiving error reports.</p><p>We also obtain data from third parties. We protect data obtained from third parties according to the practices described in this statement, ' +
      'plus any additional restrictions imposed by the source of the data. These third-party sources may vary but typically can include:</p><ul><li>Social networks when you grant permission to us to access your data on one or more networks through our website.' +
      '</li><li>Service providers that help us determine a location based on your IP address in order to customize offerings and content to your location.</li><li>Partners with which we offer co-branded services or engage in joint marketing activities, and</li><li>Other?</li></ul><p>You have choices about the data we collect. ' +
      'When you are asked to provide personal data, you may decline.  The data we collect depends on the context of your interactions with Tata Consultancy Services, and the choices you make, including your privacy settings. The data we collect can include the following:</p><p><b>Name and contact data</b>: We collect first and last name, email address, ' +
      'postal address, phone number and other similar contact data</p><p><b>Credentials</b>: We collect passwords, password hints and similar security information used for authentication and account access.</p><p><b>Demographic data</b>: We collect data about you such as your age, gender, country and preferred language.</p><p><b>Payment data</b>: ' +
      'We collect data necessary to process your payment if you make purchases, such as your payment instrument number (such as a credit card number), and the security code associated with your payment instrument.</p><p><b>Device and Usage data</b>: We collect data about your device and how you and your device interact with the Tata Consultancy Services website.' +
      '</p><p>Device, connectivity and configuration data: We collect data about your device and the network you use to connect to our website. It includes data about the operating systems and other software installed on your device, including product keys. It also includes IP address, device identifiers (such as the IMEI number for phones), regional and language settings.</p><p>Troubleshooting and Help Data: When you engage Tata Consultancy Services for troubleshooting and help, we collect data about you and your hardware, software and other details related to the incident. Such data includes contact or authentication data, the content of your chats and other communications with Tata Consultancy Services, data about the condition of the machine and the application when the fault occurred and during diagnostics, and system and registry data about software installations and hardware configurations.</p><p>Other?? ' +
      'E.g. location data, content</p><h5>Purpose of Data Uses</h5><p>Tata Consultancy Services uses the data we collect for 2 main purposes, described in more detail below: to operate our business and this website; and to send communications, including promotional communications.</p><ul><li><b>Security and Safety</b>: We use data to protect the security and safety of our website.</li><li><b>Communications</b>: We use data we collect to communicate with you and personalize our communications with you.  Additionally, you can sign up for email subscriptions and choose whether you wish to receive promotional communications from Tata Consultancy Services by email, SMS, post and telephone or other means of communication. For information about managing your contact data, email subscriptions and promotional communications, please submit a request to as using our contact form at <a href="https://www.tcs.com/contact-us" target="_new">https://www.tcs.com/contact-us</a>.' +
      '</li></ul><h5>Sharing Personal Data</h5><p>We share personal data among Tata Consultancy Services-controlled affiliates and subsidiaries. We also share personal data with vendors or agents working on our behalf for the purposes described in this statement. For example, companies we\'ve hired to provide customer service support or assist in protecting and securing our systems and services may need access to personal data to provide those functions.</p><p>We will use, access, or transfer, personal data, when it is required to:</p><ol><li>comply with applicable law or respond to valid legal process;</li><li>operate and also maintain the security of this website, including to prevent or stop an attack on our computer systems or networks; or</li><li>other?</li></ol><p>Please note that our website may include links to websites of third parties whose privacy practices differ from those of Tata Consultancy Services. ' +
      'If you provide personal data to any of those websites your data is governed by their privacy statements.</p><h5>Contacting Us</h5><p>You can make choices about our collection and use of your data.  For example, you may want to access, edit or remove the profile information or payment information in your Tata Consultancy Services account, change your password, add security information or close your account.</p><h5>Your Communications Preferences</h5><p>You can choose whether you wish to receive promotional communications from Tata Consultancy Services by email, SMS, postal mail and telephone or other communication channels. If you receive promotional email or SMS messages from us and would like to opt out, you can do so by following the directions in those messages. You can also opt out of email subscriptions and choose whether to share your contact information with Tata Consultancy Services partners.' +
      '</p><h5>Browser-Based Controls</h5><p>Cookies & Similar Technologies. Tata Consultancy Services uses cookies (small text files placed on your device) and similar technologies to provide our websites and to help collect data. The text in a cookie often consists of a string of numbers and letters that uniquely identifies your computer, but it can contain other information as well.</p><p>Our Use of Cookies and Similar Technologies. Tata Consultancy Services uses cookies and similar technologies for several purposes, which may include:</p><ul><li>Storing your Preferences and Settings. Settings that enable our website to operate correctly or that maintain your preferences over time may be stored on your device.</li><li>Sign-in and Authentication. When you sign into our website using your personal Tata Consultancy Services account, we store a unique ID number, and the time you signed in, in an encrypted cookie on your device. This cookie allows you to move from page to page within the site without having to sign in again on each page. You can also save your sign-in information so you do not have to sign in each time you return to the site.</li><li>Security. We use cookies to detect fraud and abuse of our websites and services.</li><li>Social Media. Some of our websites include social media cookies, including those that enable users who are logged in to the social media service to share content via that service.</li><li>Feedback. Tata Consultancy Services uses cookies to enable you to provide feedback on a website.</li><li>Analytics. In order to provide our website efficiently, we use cookies and other identifiers to gather usage and performance data. For example, we use cookies to count the number of unique visitors to a web page or service and to develop other statistics about the operations of our website. This includes cookies from Tata Consultancy Services and from third-party analytics providers.</li><li>Performance. Tata Consultancy Services uses cookies for load balancing to ensure that websites remain up and running.</li></ul><p>Some of the cookies we commonly use are listed below. ' +
      'This list is not exhaustive, but it is intended to illustrate the main reasons we typically set cookies. If you visit one of our websites, the site may set some or all of the following cookies:</p><h5>Describe scope of cookies use</h5><p>In addition to the cookies Tata Consultancy Services sets when you visit our websites, third parties may also set cookies when you visit Tata Consultancy Services sites. In some cases, that is because we have hired the third party to provide services on our behalf, such as site analytics. In other cases, it is because our web pages contain content from third parties, such as videos, news content or ads delivered by other ad networks. Because your browser connects to those third partie\'s web servers to retrieve that content, those third parties are able to set or read their own cookies on your device and may collect information about your online activities across websites or online services.</p><h5>How to Control Cookies</h5><p>Most web browsers automatically accept cookies but provide controls that allow you to block or delete them. For example, certain browser allow to block or delete cookies by clicking Settings--Privacy--Cookies.</p><h5>Our Use of Web Beacons and Analytics Services</h5><p>Tata Consultancy Services web pages may contain electronic images known as web beacons (also called singlepixel gifs) that we use to help deliver cookies on our websites, count users who have visited those websites and deliver co-branded products. We also may include web beacons in our email messages or newsletters to determine whether you open and act on them.</p><h5>European Data Protection Rights &#8220;GDPR&#8221;</h5><p>Below, you will find additional privacy information that you may find important. Tata Consultancy Services adheres to applicable data protection laws in the European Economic Area, which if applicable includes the following rights:</p><ul><li>If the processing of personal data is based on your consent, you have a right to withdraw consent at any time for future processing;</li><li>You have a right to request from us, a &#8220;data controller&#8221; as defined in the law, access  to and rectification of your personal data;</li><li>You have a right to object to the processing of your personal data; and</li><li>You have a right to lodge a complaint with a data protection authority.</li><p>When we process personal data about you, we do so with your consent and/or as necessary to provide the website you use, operate our business, meet our contractual and legal obligations, protect the security of our systems and our customers, or fulfill other legitimate interests of Tata Consultancy Services as described in this privacy statement.</p> </ul><h5>Security of Personal Data</h5><p>Tata Consultancy Services is committed to protecting the security of your personal data. We use a variety of security technologies and procedures to help protect your personal data from unauthorized access, use or disclosure.</p><h5>Where We Store and Process Personal Data</h5><p>Personal data collected by Tata Consultancy Services may be stored and processed in your region, in India, and in any other country where Tata Consultancy Services or its affiliates, subsidiaries or service providers operate facilities. The storage location(s) are chosen in order to operate efficiently, to improve performance and to create redundancies in order to protect the data in the event of an outage or other problem. We take steps to ensure that the data we collect under this privacy statement is processed according to the provisions of this statement and the requirements of applicable law wherever the data is located.</p><p>We transfer personal data from the European Economic Area and Switzerland to other countries, some of which have not been determined by the European Commission to have an adequate level of data protection. When we do, we use a variety of legal mechanisms, ' +
      'including contracts, to help ensure your rights and protections travel with your data.</p><h5>Our Retention of Personal Data</h5><p>Tata Consultancy Services retains personal data for as long as necessary to provide the access to and use of the website, or for other essential purposes such as complying with our legal obligations, resolving disputes and enforcing our agreements. Because these needs can vary for different data types and purposes, actual retention periods can vary significantly.</p><h5>Changes to This Privacy Statement</h5><p>We may update this privacy statement from time to time. We encourage you to periodically review this privacy statement to learn how Tata Consultancy Services is protecting your information.</p><h5>How to Contact Us</h5><p>If you have a privacy concern, complaint or a question regarding this privacy statement, please direct it to the Chief Privacy Officer of Tata Consultancy Services at <a href="mailto:cpo.tcs@tcs.com">cpo.tcs@tcs.com</a> or contact us at through this webform: <a href=\'https://www.tcs.com/contact-us\' target=\'_new\'>https://www.tcs.com/contact-us</a></p></div>'

    if (this.dataService.is_sso == true) {
      if (this.isQueryParamExist) {
        let keys = Object.keys(this.queryParams);
        if (keys.includes('issso', 0) && this.queryParams['issso'] == "true") {
          this.SSOAuthenticate()
        }
        else {
          this.router.navigate(['sso-logout'], { queryParams: { issso: 'true' } });
        }
      }
      else {
        // this.router.navigate(['sso-logout'], { queryParams: { issso: 'true' } });
        let url = this.dataService.sso_url;
         window.location.href = url;
      }
    }

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isShowStatusDiv = true;
    }, 4000);
    this.renderer.removeAttribute(this.privacyModalreff.nativeElement, 'aria-label');
    this.renderer.removeAttribute(this.privacyModalreff.nativeElement, 'aria-hidden');
  }

  SSOAuthenticate() {
    if (this.queryParams['issso'] == "true") {
      // this.commonService.setUserInfoToLocalStorage('token', this.queryParams['token']);
      this.memorystore.setItem('token', this.queryParams['token']);
      this.get_user_session_data(this.queryParams['UserName']);
    }
    else {
      this.router.navigate(['sso-logout'], { queryParams: { issso: 'true' } });
    }
  }

  createForm() {
    this.frmLogin = this.formBuilder.group({
      username: ['', (Validators.required)],
      securecode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(18)]]
    });
  }

  scrollTo(section) {
    document.querySelector('#' + section)
      .scrollIntoView();
  }

  onSubmitClick() {

    if (this.frmLogin.value.securecode != 'Tcs#1234') {
      this.commonService.showMessageBox("You are not authorized to access the application. <br>Please contact Cognix support team.", "Warning!");
      return;
    }

    if (this.dataService.Authentication_Type == "FORM" || this.dataService.Authentication_Type == "" || this.dataService.Authentication_Type == undefined) {
      // this.commonService.setUserInfoToLocalStorage('token', '');
      this.memorystore.setItem('token', '');
      this.get_user_session_data(this.frmLogin.value.username);
    }
    else {
      if (this.dataService.apiURL_Authentication != "" && this.dataService.apiURL_Authentication != undefined) {
        this.authService.login_LDAP(this.frmLogin.value).subscribe(res => {
          if (res != null && res.isUserValid == 1) {
            if (res.token != null) {
              // this.commonService.setUserInfoToLocalStorage('token', res.token);
              this.memorystore.setItem('token', res.token);
              this.get_user_session_data(this.frmLogin.value.username);
            }
          }
          else {
            this.commonService.showMessageBox("User Authentication failed.", "Warning!");
          }
        }, el => {
          this.commonService.showMessageBox("User Authentication failed." + el, "Warning!");
        });
      }
    }
  }

  get_user_session_data(userName: string) {
    this.authService.getPWMUser(userName).subscribe(user => {
      if (user != null && user.status && user.data.length > 0) {
        // this.commonService.setUserInfoToLocalStorage('userId', user.data[0].user_id);
        // this.commonService.setUserInfoToLocalStorage('userEmail', user.data[0].user_email);
        //  this.commonService.setUserInfoToLocalStorage('userName', user.data[0].display_name);
        // this.commonService.setUserInfoToLocalStorage('groupName', user.data[0].group_name);
        // this.commonService.setUserInfoToLocalStorage('groupLogo', user.data[0].group_logo);
        // this.commonService.setUserInfoToLocalStorage('projectId', user.data[0].project_id);
        // this.commonService.setUserInfoToLocalStorage('projectName', user.data[0].project_name);
        // this.commonService.setUserInfoToLocalStorage('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
        // this.commonService.setUserInfoToLocalStorage('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
        // this.commonService.setUserInfoToLocalStorage('roleId', user.data[0].role_id);
        // this.commonService.setUserInfoToLocalStorage('roleName', user.data[0].role_name);
        // this.commonService.setUserInfoToLocalStorage('isManagerialRole', user.data[0].is_managerial_role);
        // this.commonService.setUserInfoToLocalStorage('dateFormat', user.data[0].report_date_format);
        // this.commonService.setUserInfoToLocalStorage('lastLoginAt', new Date());
        // this.commonService.setUserInfoToLocalStorage('language', 'English');
        // this.commonService.setUserInfoToLocalStorage('dashboard_filters', user.data[0].dashboard_filters);
        // this.commonService.setUserInfoToLocalStorage('is_initiator', user.data[0].is_initiator);
        // this.commonService.setUserInfoToLocalStorage('is_implementation', user.data[0].is_implementation);
        this.memorystore.setItem('userId', user.data[0].user_id);
        this.memorystore.setItem('userId', user.data[0].user_id);
        this.memorystore.setuserdatainmemory('encuserId', user.data[0].encuserid);
        this.memorystore.setItem('userEmail', user.data[0].user_email);
        this.memorystore.setItem('userName', user.data[0].display_name);
        this.memorystore.setItem('groupName', user.data[0].group_name);
        this.memorystore.setItem('groupLogo', user.data[0].group_logo);
        this.memorystore.setItem('projectId', user.data[0].project_id);
        this.memorystore.setItem('projectName', user.data[0].project_name);
        this.memorystore.setItem('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
        this.memorystore.setItem('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
        this.memorystore.setItem('roleId', user.data[0].role_id);
        this.memorystore.setItem('roleName', user.data[0].role_name);
        this.memorystore.setItem('isManagerialRole', user.data[0].is_managerial_role);
        this.memorystore.setItem('dateFormat', user.data[0].report_date_format);
        this.memorystore.setItem('lastLoginAt', new Date());
        this.memorystore.setItem('language', 'English');
        this.memorystore.setItem('dashboard_filters', user.data[0].dashboard_filters);
        this.memorystore.setItem('is_initiator', user.data[0].is_initiator);
        this.memorystore.setItem('is_implementation', user.data[0].is_implementation);
        debugger;
        if (user.data[0].hasOwnProperty('logonlogoffdetailsid')) {
          // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', user.data[0].logonlogoffdetailsid);
          this.memorystore.setItem('logonLogoffDetailsId', user.data[0].logonlogoffdetailsid);

        }
        //added by dharshana on 23.06.25 for token validation.
        if (user.data[0].user_id != null && user.data[0].hasOwnProperty('logonlogoffdetailsid') && user.data[0].authtoken != null) {
          // var authtoken = this.dataService.tokenencryption(user.data[0].user_id.toString()+ user.data[0].logonlogoffdetailsid.toString());
          // this.commonService.setUserInfoToLocalStorage('authtoken', user.data[0].authtoken);
          this.memorystore.setItem('authtoken', user.data[0].authtoken);

        }
        //added by dharshana on 23.06.25 for token validation.
        // this.commonService.setUserInfoToLocalStorage('isOpenAdvanceSearch', user.data[0].is_open_advance_search);
        // this.commonService.setUserInfoToLocalStorage('isOpenHistory', user.data[0].is_open_history);
        this.memorystore.setItem('isOpenAdvanceSearch', user.data[0].is_open_advance_search);
        this.memorystore.setItem('isOpenHistory', user.data[0].is_open_history);
        if (user.data[0].is_accept_privacy_policy == 1) {
          if (user.data[0].issessionexist == "True") {
            // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', '');
            // this.commonService.setUserInfoToLocalStorage('authtoken', '');
            this.memorystore.setItem('logonLogoffDetailsId', '');
            this.memorystore.setItem('authtoken', '');
            const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: "Login",
                messageBoxType: 'question',
                icon: '',
                message: 'Your last session is seems to be open. <br> Do you want to close that session and continue?'
              }
            });
            dialogRef1.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                this.authService.killUserSession(user.data[0].logonlogoffdetailsid).subscribe(res => {
                  if (res != null && res.status == true) {
                    // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', res.data);
                    // this.commonService.setUserInfoToLocalStorage('authtoken', res.dumpdata);
                    this.memorystore.setItem('logonLogoffDetailsId', res.data);
                    this.memorystore.setItem('authtoken', res.dumpdata);
                    // if(config.is_Addprocess_In_Create_Work_page==false|| config.is_Addprocess_In_Create_Work_page==undefined){
                    if (user.data[0].project_name != "PI IDEAS") {
                      // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
                      if (this.memorystore.getItem('isManagerialRole') == 0)
                        this.router.navigate(['/control-panel']);
                      else
                        this.router.navigate(['/work-item']);
                    }
                    else {
                      //this.router.navigate(['/ibos360-dashboard-infographical']);
                      this.router.navigate(['/home']);
                    }
                    EmmiterService.get("userInfo").emit();
                  }
                  else {
                    if (res != null)
                      this.commonService.showMessageBox(res.error_message, "Login", "error");
                    else
                      this.commonService.showMessageBox("Internal error please connect AP support.", "Login", "error");

                    this.router.navigate(['/login']);
                  }
                });
              }
              else {
                return;
              }
            });
          }
          else {
            // if(user.data[0].project_name !="Al Maya - PI IDEAS"){//Commented by Ramesh R as on 11032024
            //     if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
            //       this.router.navigate(['/home']);
            //     else
            //       this.router.navigate(['/work-item']);
            // }
            // else{                          
            //     this.router.navigate(['/ibos360-dashboard-infographical']);
            // }
            // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0) {
            if (this.memorystore.getItem('isManagerialRole') == 0) {
              this.router.navigate(['/home']);
            }
            else {
              this.router.navigate(['/work-item']);
            }
            EmmiterService.get("userInfo").emit();
          }
        } else {
          this.userAcceptancePrivacyPolicyContent = user.data[0].data_privacy_content;
          this.showModal(this.userAcceptancePrivacyPolicyModal, 'xl');
        }

        this.dateFormats.display.dateInput = this.commonService.DateFormat.toUpperCase();
      }
      else {

        if (this.dataService.is_sso == true) {
          this.router.navigate(['sso-logout'], { queryParams: { issso: 'true' } });
        }
        else {
          this.commonService.showMessageBox("You are not authorized to access the application. <br>Please contact Cognix support team.", "Warning!");
          //this.commonService.showMessageBox("Authentication failed.Check Your Credentials. <br>Please contact Cognix support team.", "Warning!");
          // this.commonService.showMessageBox("Authentication failed.Please Check Your Credentials", "Warning!");
        }
      }
    });
  }

  onAzureLogin() {
    let UserName = '';
    this.msalservice.loginPopup().subscribe((resonse: AuthenticationResult) => {

      //("Response:", resonse);

      this.msalservice.instance.setActiveAccount(resonse.account)
      UserName = resonse.account.username
      if (UserName.length > 0) {
        // this.commonService.setUserInfoToLocalStorage('token', '');
        this.memorystore.setItem('token', '');
        if (this.msalservice.instance.getActiveAccount() != null) {

          this.authService.getPWMUser(UserName).subscribe(user => {
            if (user != null && user.status && user.data.length > 0) {
              // this.commonService.setUserInfoToLocalStorage('userId', user.data[0].user_id);
              // this.commonService.setUserInfoToLocalStorage('userEmail', user.data[0].user_email);
              // this.commonService.setUserInfoToLocalStorage('userName', user.data[0].display_name);
              // this.commonService.setUserInfoToLocalStorage('groupName', user.data[0].group_name);
              // this.commonService.setUserInfoToLocalStorage('groupLogo', user.data[0].group_logo);
              // this.commonService.setUserInfoToLocalStorage('projectId', user.data[0].project_id);
              // this.commonService.setUserInfoToLocalStorage('projectName', user.data[0].project_name);
              // this.commonService.setUserInfoToLocalStorage('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
              // this.commonService.setUserInfoToLocalStorage('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
              // this.commonService.setUserInfoToLocalStorage('roleId', user.data[0].role_id);
              // this.commonService.setUserInfoToLocalStorage('roleName', user.data[0].role_name);
              // this.commonService.setUserInfoToLocalStorage('isManagerialRole', user.data[0].is_managerial_role);
              // this.commonService.setUserInfoToLocalStorage('dateFormat', user.data[0].report_date_format);
              // this.commonService.setUserInfoToLocalStorage('lastLoginAt', new Date());
              // this.commonService.setUserInfoToLocalStorage('language', 'English');
              // this.commonService.setUserInfoToLocalStorage('dashboard_filters', user.data[0].dashboard_filters);
              this.memorystore.setItem('userId', user.data[0].user_id);
              this.memorystore.setItem('userEmail', user.data[0].user_email);
              this.memorystore.setItem('userName', user.data[0].display_name);
              this.memorystore.setItem('groupName', user.data[0].group_name);
              this.memorystore.setItem('groupLogo', user.data[0].group_logo);
              this.memorystore.setItem('projectId', user.data[0].project_id);
              this.memorystore.setItem('projectName', user.data[0].project_name);
              this.memorystore.setItem('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
              this.memorystore.setItem('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
              this.memorystore.setItem('roleId', user.data[0].role_id);
              this.memorystore.setItem('roleName', user.data[0].role_name);
              this.memorystore.setItem('isManagerialRole', user.data[0].is_managerial_role);
              this.memorystore.setItem('dateFormat', user.data[0].report_date_format);
              this.memorystore.setItem('lastLoginAt', new Date());
              this.memorystore.setItem('language', 'English');
              this.memorystore.setItem('dashboard_filters', user.data[0].dashboard_filters);

              if (user.data[0].is_accept_privacy_policy == 1) {
                // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
                if (this.memorystore.getItem('isManagerialRole') == 0)
                  this.router.navigate(['/control-panel']);
                else
                  this.router.navigate(['/work-item']);
                EmmiterService.get("userInfo").emit();
              } else {
                this.userAcceptancePrivacyPolicyContent = user.data[0].data_privacy_content;
                this.showModal(this.userAcceptancePrivacyPolicyModal, 'xl');
              }
              this.dateFormats.display.dateInput = this.commonService.DateFormat.toUpperCase();
            }
            else {

              this.commonService.showMessageBox("User Authentication failed.", "Warning!");
            }
          });
        }
      }
    });
  }

  acceptPrivacyPolicy() {
    // this.authService.acceptPrivacyPolicy(Number(this.commonService.getUserInfoFromLocalStorage('userId'))).subscribe(res => {
    this.authService.acceptPrivacyPolicy(Number(this.memorystore.getItem('userId'))).subscribe(res => {
      if (res.status) {
        this.modalReference.close();
        // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
        if (this.memorystore.getItem('isManagerialRole') == 0)
          this.router.navigate(['/control-panel']);
        else
          this.router.navigate(['/work-item']);
        EmmiterService.get("userInfo").emit();
      }
    });

  }

  showModal(modelTemplate, modalSize: string = 'lg') {

    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  loadScript(src: string) {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = src;
    script.nonce = "cd90d3070658eb370a6e152dc25dc04f";
    script.async = true;
    script.defer = true;
    if (self === top) {
      var antiClickjack = document.getElementById("antiClickjack");
      antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
      //top.location = self.location;
    }
    body.appendChild(script);
  }
}
